import { MHC } from '../store/types/medicalHistory';
import { PUSH_PT_MED_HISTORY } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Request {
    patientHistory: MHC;
    created_at: string;
}

export default (
    docId: string,
    ptId: string,
    patientHistory: MHC,
    created_at: string,
): Promise<Response> => {
    const req: Request = {
        patientHistory: patientHistory,
        created_at: created_at,
    };
    return fetchWithRefresh(PUSH_PT_MED_HISTORY(docId, ptId), {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('Error pushing mh');
        }
    });
};
